<template>
  <div class="home conten bg-white">
    <Header></Header>
    <!-- <van-notice-bar mode="link">技术是开发它的人的共同灵魂。</van-notice-bar> -->
    <Custome></Custome>
    <Swiper v-if='dataList' :swiperList=swiperList ></Swiper>
    <Course></Course>
    <!-- <div class='lineF4'></div> -->
    <LiveClass :liveList="liveList" v-if="liveList != undefined && liveList.length > 0" />
    <!-- <div class='lineF4'></div> -->
    <List v-if='dataList' class="padding15" :dataList=dataList style="padding-bottom:3rem"></List>
    <!-- <Gohome  @click="goHome"></Gohome> -->
    <Footer></Footer>
  </div>
  
</template>

<script>
// import Gohome from '@/components/gohome/gohome'
import Header from '@/components/header'
import Swiper from '@/components/swiper'
import Custome from '@/components/customer'
import Course from '@/components/course'
import Footer from '@/components/footer'
import LiveClass from '@/components/home/liveClass'

import { getIndexInfo } from '@/model/home/homeServe'
import List from '@/components/list/courseList'
export default {
  name:'Home',
  data(){
    return {
      areaCode:86,
      dataList:[],
      swiperList:[],
      wxLogin:{
        appid:"wx56319ab0cbf4077b",
        scope:"snsapi_userinfo",   // snsapi_userinfo    ||    snsapi_login
        self_redirect:false,
        redirect_uri:"http://mceshi.xzjy365.com",
        response_type:"code",
        state:"STATE#wechat_redirect",
        code:"",
        secret:"b8f600cfaaaee2aa6d73075930dd4df1"
      },
      QQLogin :{
        code:"",  // QQ返回的code
        redirect_url:"http://mceshi.xzjy365.com/index",   // 返回的地址  
      },
      openId:"",
      accessToken :"",
      liveList:[],  // 存放直播列表
    }
  },
  components: {
    Header,
    Swiper,
    List,
    Custome,
    Course,
    Footer,
    LiveClass,
    // Gohome
  },
  created(){
    // this.getCode()
    // 首页信息
    getIndexInfo().then(data => {
      this.dataList = data.data.course
      this.swiperList = data.data.slides
      this.liveList = data.data.liveList
    })
  },
  methods: {
    goHome(){
      this.$router.push({
          path:'/',
      })
    },
    // 获取微信返回的code
    getCode(){
      if(this.$route.query.code == undefined && this.$route.query.openId == undefined){   // 如果微信的code和QQ的id都为空 返回
        return false
      }
      if(this.$route.query.code != undefined){
        this.wxLogin.code = this.$route.query.code
        let data = {
          code:this.wxLogin.code,
          uid:localStorage.getItem("uid")
        }
        this.Api({
          url:'api/getaccess_tokenBycode',
          method:'POST',
          data
        }).then(res => {
          this.$toast('微信授权登录')
          this.detectBind(res.data)
        }).catch(() => {
          alert('失败微信登录,请联系学习规划老师')
        })
      }else if( this.$route.query.openId != undefined){
        let data = {
          qqOpenid:this.$route.query.openId,
          accessToken:this.$route.query.accessToken,
          uid:localStorage.getItem("uid")
        }
        this.Api({
          url:'api/qq/get_access_token',
          method:"POST",
          data
        }).then(res => {
          // if(res.message == "sussecc"){
            this.$toast('QQ授权登录成功')
            this.detectBind(res.data)
          // }
        }).catch(() => {
          alert("QQ授权登录失败,请联系学习规划老师")
        })
      }
    },
    // 检测是否绑定了微信和QQ
    detectBind(data){
      this.$store.commit("Login/editPersonalInfo",data)
      localStorage.setItem("uid",data.uid)
      if(data.qqOpenid != null){
        this.$store.commit("Login/editQqBingType",true)
        localStorage.setItem("qqOpenidType",data.qqOpenid)
      }
      if(data.wxOpenid != null){
        this.$store.commit("Login/editWxBingType",true)
        localStorage.setItem("wxOpenidType",data.wxOpenid)
      }
    },
  },


}
</script>
<style lang="less" scoped>
.lineF4{
  height:7/20rem;
  background:rgba(244,244,244,1);
}
</style>